<template>
  <div class="ud-empty-row" :style="{ height: height + 'px', backgroundColor: color }">
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: [Number, String],
      default: 18
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0)'
    }
  }
}
</script>

<style lang="scss" scoped>
.ud-empty-row {
  position: relative;
  width: 100%;
  overflow: hidden;
  z-index: 1;
}
</style>